/**
 * @generated SignedSource<<f602b3213f22bdf8f4d0cba101775046>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentTitle_space$data = {
  readonly id: string | null;
  readonly lookAndFeel: {
    readonly content: {
      readonly header: {
        readonly background: string | null;
        readonly backgroundAttachment: string | null;
        readonly backgroundBlendMode: string | null;
        readonly backgroundClip: string | null;
        readonly backgroundColor: string | null;
        readonly backgroundImage: string | null;
        readonly backgroundOrigin: string | null;
        readonly backgroundPosition: string | null;
        readonly backgroundRepeat: string | null;
        readonly backgroundSize: string | null;
        readonly borderRadius: string | null;
        readonly padding: string | null;
      } | null;
    } | null;
    readonly headings: ReadonlyArray<{
      readonly key: string | null;
      readonly value: string | null;
    } | null>;
  } | null;
  readonly theme: {
    readonly themeKey: string | null;
  } | null;
  readonly " $fragmentType": "ContentTitle_space";
};
export type ContentTitle_space$key = {
  readonly " $data"?: ContentTitle_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentTitle_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ContentTitle_space",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "Theme",
      "kind": "LinkedField",
      "name": "theme",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "themeKey"
        }
      ]
    },
    {
      "concreteType": "LookAndFeel",
      "kind": "LinkedField",
      "name": "lookAndFeel",
      "plural": false,
      "selections": [
        {
          "concreteType": "MapOfStringToString",
          "kind": "LinkedField",
          "name": "headings",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        },
        {
          "concreteType": "ContentLookAndFeel",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "concreteType": "ContainerLookAndFeel",
              "kind": "LinkedField",
              "name": "header",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "background"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundAttachment"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundBlendMode"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundClip"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundColor"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundImage"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundOrigin"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundPosition"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundRepeat"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundSize"
                },
                {
                  "kind": "ScalarField",
                  "name": "borderRadius"
                },
                {
                  "kind": "ScalarField",
                  "name": "padding"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Space"
};

(node as any).hash = "4554ec437025ed6932758ad73dffd78f";

export default node;
